<script setup lang="ts">
import Header from '@/components/Header.vue';
import ModalFromBot from '@/components/Modal/ModalFromBot.vue';
import router from '@/router';
import _service from '@/service';
import { useAccountStore } from '@/stores/account';
import { $BigNumber, exportCanvasAsPNG, isDev, isInIframe, symbolByCurrency } from '@/utils';
import { transact } from '@/utils/transact';
import { closeToast, showLoadingToast, showToast } from 'vant';
import QrcodeVue from 'qrcode.vue'
import { computed, onMounted } from 'vue';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import clipboard3 from 'vue-clipboard3'
import { onUnmounted } from 'vue';
import { watch } from 'vue';
import html2canvas from 'html2canvas'
import { isStarNest } from '@/utils/starnest';
import { useSystemStore } from '@/stores/system';
import { getArmadilloClient } from '@/utils/armadillo';
import { isApp } from '@/utils/device';
const { toClipboard } = clipboard3()

const isShowCodePayModal = ref<boolean>(false)
const isShowCoinQOptions = ref<boolean>(false)
const hasGotType = ref<boolean>(false)
const payTypeIndex = ref<number>(0);
const payOrderId = ref<number>(0);
const childrenIndex = ref<number>(0);
const chainPayTypeIndex = ref<number>(0);
const payChannelData = ref<any>();
const balanceMapping = ref<any>();
const payOrderData = ref<any>({});
const timer = ref<any>(null);
const QrCode = ref<string>('');
const wxPayQrCode = ref<string>('');
const payTypeCode = ref<string>('');
const accountStore = useAccountStore()
const {t} = useI18n()
const starSpuId = 659
const starSkuId = 132
const starPropertyId = 25
const payTypeList = ref<any>([]);
const ORDER_DATA = JSON.parse(sessionStorage.getItem('ORDER_DATA') || '')?.orderData
const STAR_DATA = JSON.parse(sessionStorage.getItem('ORDER_DATA') || '')?.starData
const STARNEST_DOWNLOAD = `${import.meta.env.VITE_STARNEST_DOWNLOAD}#download`
console.log(STARNEST_DOWNLOAD,'STARNEST_DOWNLOAD');
console.log(ORDER_DATA,'ORDER_DATA');
console.log(STAR_DATA,'STAR_DATA');
const parentUrl = sessionStorage.getItem('PARENT_URL')
const returnUrl = isInIframe() ? `${parentUrl}?status=success`: `${window.location.origin}/pay-success`
// {
//   name:'MUSDT',
//   type:'AMAX'
// },
// {
//   name:'CoinQ Pay',
//   type:'USDT'
// },
// {
//   name:'USDT',
//   type:'TRON'
// },
// {
//   name:'USDT',
//   type:'ETH'
// }

const systemStore = useSystemStore()

const globalCurrency = computed(()=>{
  return systemStore.globalCurrency
})


const getPayType = async () => {
  if (hasGotType.value) {
    return false
  }
  hasGotType.value = true
  try {
    const {orderData,starData} = JSON.parse(sessionStorage.getItem('ORDER_DATA') || '')
    showLoadingToast({
      message: t("Loading"),
      duration: 0
    })
    console.log(orderData,'orderData');
    const payOrder:any = await _service.getPayOrderDetail({id:orderData.payOrderId})
    console.log(payOrder,'payOrder');
    payOrderData.value = payOrder?.data
    if (payOrder?.data?.payChannelIds) {
      let {data} = await _service.getPayChannelSort({appId:1,channelIds:payOrder?.data?.payChannelIds})
      const _payChannelList = data.map((item:any,index:number)=>{
          item.channelData.map((channelItem:any,channelIndex:number)=>{
            channelItem.coins.map(async(coinItem:any,coinIndex:number) => {
                coinItem.index = `${index}-${ channelIndex}-${coinIndex}`
                if (channelItem.code === 'amax_chain') {
                  if (isStarNest && window.armadillo) {
                    // 在starnest app里或者开发环境展示链上支付
                    const rows:any = await _service.getBalanceByUser({
                      code:coinItem.contract,
                      account: accountStore.getUserInfo.name,
                      symbol:coinItem.symbol,
                    })
                    const _balance = rows.length ? rows[0].split(' ')[0] : 0
                    balanceMapping.value = new Map([
                      [coinItem.symbol,_balance]
                    ])
                  }else{
                    // 删除链支付
                    item.channelData.splice(channelIndex, 1)
                  }
                }
                return coinItem
              });
            if (channelItem.coins.length > 1 || channelItem.name === 'On-Chain Payment') {
              channelItem.children = channelItem.coins
            }else{
              channelItem.children = null
            }

            return channelItem
          })
          return item
        })

      payTypeList.value = _payChannelList
    }
    closeToast()
  } catch (error) {
    closeToast()
    showToast(`${error}`)
  }
}
const copy = async (text:string) => {
  await toClipboard(text)
  showToast(t('Copied'))
}


const doopay = async() => {
  // doopay支付
  try {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    console.log(payChannelData.value,'payChannelData');

    const orderData = {
      id:ORDER_DATA.payOrderId,
      channelCode:payChannelData.value?.code,
      channelExtras:{
        currency:payChannelData.value?.coins[0].coin,
        tarCurrency:payChannelData.value?.coins[0].coin,
        account:accountStore.getUserInfo.name
      },
      displayMode:'url',
      returnUrl
    }
    console.log(orderData,'orderdata');
    const res:any = await _service.submitOrder(orderData)
    if (!res.data) {
      window.location.replace(`${window.location.origin}/pay-fail`)
      return false
    }
    if (res.data.displayMode === 'url') {
      window.location.href = res.data.displayContent
    }
    closeToast()
  } catch (error) {
    console.error(error)
  }
}

const moneyCollectPay = () => {
  // console.log(STAR_DATA,'STAR_DATA');
  // console.log(payChannelData.value,'payChannelData');
  // console.log(ORDER_DATA,'ORDER_DATA');
  
  // const _pay_obj = {
  //     "productName": STAR_DATA.name,
  //     "price":Number($BigNumber(STAR_DATA.initialPrice).times(STAR_DATA.quantity || 1).times(payChannelData.value.coins[childrenIndex.value]?.exchangeRate || 1).div(100)),
  //     "quantity": STAR_DATA.quantity,
  //     "id": ORDER_DATA.payOrderId,
  //     "no": ORDER_DATA.no,
  //     "createTime": payOrderData.value.createTime,
  //     "expireTime": payOrderData.value.expireTime,
  //     "payChannel": payChannelData.value.code,
  //     "coin": payChannelData.value.coins[0].coin
  // }
  // router.push(`/creditcard-payment?params=${JSON.stringify(_pay_obj)}`)
}

const alyssaPay = () => {
  console.log(STAR_DATA,'STAR_DATA');
  console.log(payChannelData.value,'payChannelData');
  console.log(ORDER_DATA,'ORDER_DATA');
  
  const _pay_obj = {
      "productName": STAR_DATA.name,
      "price":Number($BigNumber(STAR_DATA.initialPrice).times(STAR_DATA.quantity || 1).times(payChannelData.value.coins[childrenIndex.value]?.exchangeRate || 1).div(100)),
      "quantity": STAR_DATA.quantity,
      "id": ORDER_DATA.payOrderId,
      "no": ORDER_DATA.no,
      "createTime": payOrderData.value.createTime,
      "expireTime": payOrderData.value.expireTime,
      "payChannel": payChannelData.value.code,
      "coin": payChannelData.value.coins[0].coin
  }
  router.push(`/creditcard-payment?params=${JSON.stringify(_pay_obj)}`)
}

const chainPay = async () =>{
  if (+payChannelData.value.coins[childrenIndex.value].balance < STAR_DATA.totalPrice) {
    showToast(t('Insufficient balance'))
    return false
  }
  // 链上划转
  try {
    const price = Number($BigNumber(STAR_DATA.initialPrice * STAR_DATA.quantity).times(payChannelData.value.coins[0].exchangeRate || 1).div(100))
    const orderDetail = await _service.getOrderDetail({id:ORDER_DATA.id})
    const {contract,symbol,precision} = payChannelData.value.coins[0]
    const actions: any = [];
    console.log(payChannelData,'payChannelData');

    const _data = {
      account: contract,
      name: "transfer",
      data: {
        from:accountStore.getUserInfo.name,
        to:import.meta.env.VITE_APP_PAY,
        quantity:`${price.toFixed(precision)} ${symbol}`,
        memo: `${ORDER_DATA.no}:1:1:${orderDetail.data?.payExpireTime}`
      },
    };
    actions.push(_data);
    console.log(actions, "actions---");
    await transact(actions);
    router.push('/pay-success')
  } catch (error) {
    console.error(error);
  }
}

const coinQPay = async () => {
  try {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    const orderData = {
      id:ORDER_DATA.payOrderId,
      channelCode:payChannelData.value?.code,
      channelExtras:{
        coin:payChannelData.value?.coins[childrenIndex.value].coin,
      },
      displayMode:'url',
      returnUrl
    }
    console.log(orderData,'orderdata');
    const res:any = await _service.submitOrder(orderData)
    if (!res.data) {
      showToast(res.msg)
      return false
    }else if (res.data.displayMode === 'qr_code') {
      QrCode.value = res.data?.displayContent
      isShowCodePayModal.value = true
      getPayResultInterval()
    }
    closeToast()
  } catch (error) {
    console.error(error)
  }
}

const stripePay = async() => {
  // stripePay支付
  try {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    console.log(payChannelData.value,'payChannelData');

    const orderData = {
      id:ORDER_DATA.payOrderId,
      channelCode:payChannelData.value?.code,
      channelExtras:{
        cancelUrl:`${window.location.origin}/pay-fail`
      },
      displayMode:'url',
      returnUrl
    }
    console.log(orderData,'orderdata');
    const res:any = await _service.submitOrder(orderData)
    if (!res.data) {
      window.location.replace(`${window.location.origin}/pay-fail`)
      return false
    }
    if (res.data.displayMode === 'url') {
      window.top.location.href = res.data.displayContent;
      // window.location.href = res.data.displayContent
    }
    closeToast()
  } catch (error) {
    console.error(error)
  }
}

const wxPay = async () => {
  try {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    const orderData = {
      id:ORDER_DATA.payOrderId,
      channelCode:payChannelData.value?.code,
      channelExtras:{
        coin:payChannelData.value?.coins[childrenIndex.value].coin,
      },
      displayMode:'url',
      returnUrl
    }
    console.log(orderData,'orderdata');
    const res:any = await _service.submitOrder(orderData)
    console.log(res,'res');
    if (!res.data) {
      showToast(res.msg)
      return false
    }else if (res.data.displayMode === 'qr_code') {
      QrCode.value = res.data?.displayContent
      isShowCodePayModal.value = true
      getPayResultInterval()
    }
    closeToast()
  } catch (error) {
    console.error(error)
  }
}

const wechatAliPay = async () => {
  try {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    console.log(payChannelData.value,'payChannelData');
    console.log(payOrderData.value,'payChannelData');

    const orderData = {
      id:ORDER_DATA.payOrderId,
      channelCode:payChannelData.value?.code,
      channelExtras:{
        priceSymbol: payOrderData.value.priceSymbol,
      },
      displayMode:'url',
      returnUrl
    }
    console.log(orderData,'orderdata');
    const res:any = await _service.submitOrder(orderData)
    if (!res.data) {
      window.location.replace(`${window.location.origin}/pay-fail`)
      return false
    }
    if (res.data.displayMode === 'url') {
      window.top.location.href = res.data.displayContent;
      // window.location.href = res.data.displayContent
    }
    closeToast()
  } catch (error) {
    console.error(error)
  }
}

const futurePay = async () => {
  try {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    console.log(payChannelData.value,'payChannelData');
    console.log(payOrderData.value,'payChannelData');

    const orderData = {
      id:ORDER_DATA.payOrderId,
      channelCode:payChannelData.value?.code,
      channelExtras:{
        priceSymbol: payOrderData.value.priceSymbol,
        cancelUrl:`${window.location.origin}/pay-fail`
      },
      displayMode:'url',
      returnUrl
    }
    console.log(orderData,'orderdata');
    const res:any = await _service.submitOrder(orderData)
    if (!res.data) {
      window.location.replace(`${window.location.origin}/pay-fail`)
      return false
    }
    if (res.data.displayMode === 'url') {
      window.top.location.href = res.data.displayContent;
      // window.location.href = res.data.displayContent
    }
    closeToast()
  } catch (error) {
    console.error(error)
  }
}


const getPayResultInterval = async() => {
  const {data} = await _service.getOrderPayStatus({id:ORDER_DATA.payOrderId})
  switch (data) {
    case 30:
      window.location.replace(`${window.location.origin}/pay-fail`)
      break;
    case 10:
      window.location.replace(`${window.location.origin}/pay-success`)
      break;
    case 0:
      timer.value = setTimeout(() => {
        getPayResultInterval()
      },5000)
      break;
    default:

      break;
  }

}

const payFn = async() => {
  console.log('pay');
  const actions: any = [];
  console.log(payOrderData.value,'payOrderData.value');
  // isApp  || isInIframe() || isDev
  const urlParams = new URLSearchParams(window.location.search)
  console.log(urlParams.get('integral'),'urlParams');
  const isIntegral = urlParams.get('integral') === 'true'
  
  let minPayAmount = 0
  if (payChannelData.value.coins.length > 1) {
    minPayAmount = +payChannelData.value.coins[childrenIndex.value].minimumPayAmount / 100
  }else{
    minPayAmount = +payChannelData.value.coins[0].minimumPayAmount / 100
  }
  if ($BigNumber(STAR_DATA.totalPrice || 0).times(payChannelData.value.coins[childrenIndex.value].exchangeRate || 1) < minPayAmount) {
    showToast(`${payChannelData.value.remark} ${t('Minimum')}:${minPayAmount} ${payChannelData.value.coins[childrenIndex.value].displayCode}`)
    return false
  }
  if (isIntegral) {
    //链上支付
    //integralActionsPost
    const orderDetail = await _service.getOrderDetail({id:ORDER_DATA.id})
    const _data = {
      account:import.meta.env.VITE_STAR_CONTRACT,
      name: "transfer",
      data: {
        from:accountStore.getUserInfo.name,
        to:import.meta.env.VITE_APP_PAY,
        quantity:`${$BigNumber(STAR_DATA.payIntegral).toFixed(4)} STAR`,
        memo: `integral:${ORDER_DATA.no}:1:1:${orderDetail.data.payExpireTime}`
      },
    };
    actions.push(_data);
    console.log(actions, "actions---");
    const res = await transact(actions,{broadcast: false,expireSeconds: 3610});
    console.log(res,'res');
    const {api}:any  = await getArmadilloClient()
    const actionsPostData = {
      "tx": await api.deserializeTransaction(Object.values(res.serializedTransaction)),
      "appId": "1",
      "sign": res.signatures[0],
      "orderNo": ORDER_DATA.no
    }
    const {data}:any = await _service.integralPay(actionsPostData)
    if (!data) {
      return false
    }
  }
  console.log(payChannelData.value.remark,'payChannelData.value.remark');

  const _pay_obj = {
      "sku": starSkuId,
      "productName": STAR_DATA.name,
      "price":Number($BigNumber(STAR_DATA.initialPrice).times(STAR_DATA.quantity || 1).times(payChannelData.value.coins[childrenIndex.value]?.exchangeRate || 1).div(100)),
      "quantity": STAR_DATA.quantity,
      "id": ORDER_DATA.payOrderId,
      "no": ORDER_DATA.no,
      "createTime": payOrderData.value.createTime,
      "expireTime": payOrderData.value.expireTime,
      "payChannel": payChannelData.value.code,
      "coin": payChannelData.value.coins[0].coin
  }
  switch (payChannelData.value.code) {
    case '8388-0edccb4de':
      console.log('doopay pay');
      doopay()
      break;
    case 'money_collect_pay':
      console.log('money_collect_pay pay');
      moneyCollectPay()
      break;
    case 'alyssa_pay':
      console.log('alyssa_pay pay');
      alyssaPay()
      break;
    case '5944-e2aa304e0':
      console.log('doopay pay');
      doopay()
      break;
    case 'amax_chain':
      console.log('chain pay');
      chainPay()
      break;
    case 'coinq_pay':
      console.log('coinQPay pay');
      coinQPay()
      break;
    case 'allinpay_cnp':
      console.log('allinpay pay');
      console.log(payChannelData.value,'payChannelData.value');
      router.push(`/payment?params=${JSON.stringify(_pay_obj)}`)
      break;
    case 'allinpay_alipay' :
      console.log('alipay pay');
      router.push(`/payment?params=${JSON.stringify(_pay_obj)}`)
      break;
    case 'allinpay_wxpay' :
      console.log('wx pay');
      wxPay()
      break;
    case 'future_pay' :
      console.log('future pay');
      futurePay()
      break;
    case 'wallyt_Alipay' :
      console.log('wallyt_Alipay pay');
      wechatAliPay()
      break;
    case 'wallyt_wxpay' :
      console.log('wallyt_wxpay pay');
      wechatAliPay()
      break;
    case 'fps_pay' :
      console.log('fpspay');
      console.log(_pay_obj,'_pay_obj');
      _pay_obj.price = Number($BigNumber(STAR_DATA.initialPrice).times(STAR_DATA.quantity || 1).times(payChannelData.value.coins[childrenIndex.value]?.exchangeRate || 1).div(100).toFixed(2))
      _pay_obj.coin = payOrderData.value?.priceSymbol
      router.push(`/other-payment?params=${JSON.stringify(_pay_obj)}`)
      break;
    case 'payme_pay' :
      console.log('payme');
      _pay_obj.price = Number($BigNumber(STAR_DATA.initialPrice).times(STAR_DATA.quantity || 1).times(payChannelData.value.coins[childrenIndex.value]?.exchangeRate || 1).div(100).toFixed(2))
      _pay_obj.coin = payOrderData.value?.priceSymbol
      router.push(`/other-payment?params=${JSON.stringify(_pay_obj)}`)
      break;
    case 'stripe_hosted_pay' :
      console.log('stripe');
      stripePay()
      break;
    default:
      break;
  }
}

const choosePayType = (index:string) => {
 let _arr =  index.split('-')
  payTypeCode.value = index
  payChannelData.value = payTypeList.value[_arr[0]].channelData[_arr[1]]
  childrenIndex.value = +_arr[2]
}


const saveImage = ()=>{
  const el:HTMLElement | null = document.querySelector("#poster")
  el && html2canvas(el).then(canvas => {
    canvas.setAttribute('id','codeCanvas')
    canvas.setAttribute('style','position: fixed;left: -1000%;top: -1000%;')
    document.body.appendChild(canvas)
    exportCanvasAsPNG('codeCanvas','STAR PAY CODE')
    document.body.removeChild(canvas);
  });

}

// const fee = computed(()=>{
//   console.log(payChannelData.value,'payChannelData');

//   const price = $BigNumber((number.value || 0)).times(starData.value?.price || 0)
//   return $BigNumber(payChannelData.value?.feeRate || 0).times(price)
// })

watch(()=>isShowCodePayModal.value,(val)=>{
  if (!val) {
    clearTimeout(timer.value)
  }
})

watch(()=>accountStore.getUserInfo.name,(val)=>{
  if (val) {
    getPayType()
  }
})

onMounted(async()=>{
  if (isStarNest && accountStore.getUserInfo.name) {
    getPayType()
  }else{
    getPayType()
  }
})

onUnmounted(()=>{
  clearTimeout(timer.value)
})
</script>

<template>
  <div class="star-layout">
    <Header />
    <div class="media-375">
      <div class="rate-tip">
        {{ t("Rate tip") }}
      </div>
      <!-- <p class="title">{{t('Select Payment Method')}}</p> -->
      <div class="pay-type-list list-wrapper">
        <div
          class="pay-type-list-item"
          v-for="item in payTypeList"
          :key="item.name"
        >
          <div class="type-name">{{ t(item.name) }}</div>
          <div class="paytool-list">
            <div
              class="paytool-list-item"
              :class="
                item.name === 'On-Chain Payment' ? 'noheight nopadding' : ''
              "
              v-for="item2 in item.channelData"
              :key="item2.code"
              @click.stop="choosePayType(item2.coins[0].index)"
            >
              <div
                class="group-name"
                style="padding-top: 0"
                v-if="item.name === 'On-Chain Payment'"
              >
                <!-- <div class="group-name-text">{{ item2.remark }}</div> -->
                <div
                  class="paytool-list-item nopadding"
                  v-for="item3 in item2.coins"
                  :key="item3.symbol"
                  @click.stop="choosePayType(item3.index)"
                >
                  <img class="icon" :src="item3?.coinUrl" alt="" />
                  <div class="text" v-if="item2.code === 'amax_chain'">
                    {{ item3.symbol }} ({{
                      `${t("Balance")}:${
                        balanceMapping?.get(item3.symbol) || 0
                      }`
                    }})
                  </div>
                  <div class="text" v-else>
                    {{ `${item3.displayCode}` }}
                    <span class="small-text">
                      {{
                        ` (${item3.channel}) ${t("Minimum")}:${
                          item3.minimumPayAmount / 100
                        } ${item3.displayCode}`
                      }}</span
                    >
                  </div>
                  <div class="check-area">
                    <div
                      class="check"
                      v-if="payTypeCode === item3?.index"
                    ></div>
                  </div>
                </div>
              </div>
              <template v-else>
                <img class="icon" :src="item2?.coins[0]?.coinUrl" alt="" />
                <div class="text">
                  {{ item2.remark
                  }}<span class="small-text">{{
                    `(${item2.coins[0].coin})`
                  }}</span
                  ><img
                    class="card-img"
                    src="../../assets/pay/credit-card.svg"
                    v-if="item.name === 'Credit Card'"
                    alt=""
                  />
                </div>
                <div class="check-area">
                  <div
                    class="check"
                    v-if="payTypeCode === item2?.coins[0]?.index"
                  ></div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-bar media-375-fixed">
        <div
          class="pay-btn flex-row-center-center"
          :class="{ disabled: !payChannelData }"
          @click="payFn"
        >
          {{ t("Next step") }}
        </div>
      </div>
      <ModalFromBot v-model:is-show="isShowCodePayModal">
        <div class="code-pay-modal flex-col-center-center">
          <p class="title">
            {{ payChannelData?.code === "allinpay_wxpay" ? "Wechat " : ""
            }}{{ t("Payment") }}
          </p>
          <div class="code">
            <qrcode-vue
              :value="QrCode"
              :margin="2"
              :size="160"
              level="H"
            ></qrcode-vue>
          </div>
          <div
            class="copy-bar number-font"
            v-if="payChannelData?.code !== 'allinpay_wxpay'"
          >
            <span class="code-text">{{ QrCode }}</span>
            <i class="copy-icon" @click="copy(QrCode)"></i>
          </div>
          <div class="price flex-row-start-center">
            {{ t("Amount") }}：<span class="number-font"
              >{{
                $BigNumber(STAR_DATA.initialPrice * STAR_DATA.quantity)
                  .times(
                    payChannelData?.coins
                      ? +payChannelData?.coins[childrenIndex]?.exchangeRate
                      : 0
                  )
                  .div(100)
                  .toFixed(2)
              }}
              {{
                payChannelData?.coins
                  ? payChannelData?.coins[childrenIndex]?.displayCode
                  : ""
              }}
              <span v-if="payChannelData?.code !== 'allinpay_wxpay'"
                >({{
                  payChannelData?.coins
                    ? payChannelData?.coins[childrenIndex]?.channel
                    : ""
                }})</span
              ></span
            >
          </div>
          <div class="save-btn" @click="saveImage">{{ t("Save QR code") }}</div>
          <div class="tip" v-if="payChannelData?.code !== 'allinpay_wxpay'">
            {{ t("QRCodeTip") }}
          </div>
        </div>
      </ModalFromBot>
      <div id="poster">
        <div class="poster-main">
          <div class="poster-title">
            {{ payChannelData?.code === "allinpay_wxpay" ? "Wechat " : ""
            }}{{ t("Scan QR code to pay") }}
          </div>
          <div class="code">
            <qrcode-vue
              :value="QrCode"
              :margin="3"
              :size="205"
              level="H"
            ></qrcode-vue>
          </div>
          <div class="price flex-row-start-center">
            {{ t("Amount") }}：<span class="number-font"
              >{{
                $BigNumber(STAR_DATA.initialPrice * STAR_DATA.quantity)
                  .times(
                    payChannelData?.coins
                      ? +payChannelData?.coins[childrenIndex]?.exchangeRate
                      : 0
                  )
                  .div(100)
                  .toFixed(2)
              }}
              {{
                payChannelData?.coins
                  ? payChannelData?.coins[childrenIndex]?.displayCode
                  : ""
              }}
              <span v-if="payChannelData?.code !== 'allinpay_wxpay'"
                >({{
                  payChannelData?.coins
                    ? payChannelData?.coins[childrenIndex]?.channel
                    : ""
                }})</span
              ></span
            >
          </div>
          <div
            class="code-text"
            v-if="payChannelData?.code !== 'allinpay_wxpay'"
          >
            {{ QrCode }}
          </div>
        </div>
        <div class="poster-footer flex-row-between-center">
          <div class="left flex-col-start-start">
            <img src="../../assets/starnest-logo.png" class="logo" />
            <div class="text">{{ t("DownloadTip") }}</div>
          </div>
          <qrcode-vue
            :value="STARNEST_DOWNLOAD"
            :margin="2"
            :size="60"
            level="H"
          ></qrcode-vue>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.star-layout {
  height: 100%;
  min-height: 100vh;
  background: #070b14;
  .title {
    color: #fff;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 12px;
  }
  .header {
    padding: 10px 16px;

    .wallet {
      display: flex;
      padding: 8px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: 10px;
      border: 1px solid #303342;
      font-size: 12px;
      color: #9c9caa;
      .icon {
        width: 16px;
        height: 16px;
        background: url(../../assets/star/wallet.svg);
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
    .locale {
      width: 24px;
      height: 24px;
      background: url(../../assets/star/locale.svg);
      background-size: contain;
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }
  .row-box-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;
    margin-top: 34px;
  }
  .row-box {
    width: 100%;
    font-size: 20px;
    color: #fff;
    font-weight: 700;
    .inputer {
      border-radius: 12px;
      background: #1f212d;
      width: 100%;
      height: 58px;
      padding: 8px 14px;
      margin-top: 10px;

      input {
        flex: 1;
        color: #fff;
        font-size: 18px;
        &::placeholder {
          color: #9c9caa;
        }
        &.center {
          text-align: center;
        }
      }
      .gray {
        font-size: 14px;
        color: #9c9caa;
      }
      .drop-down-icon {
        width: 24px;
        height: 24px;
        background: url(../../assets/drop-down-icon.svg);
        background-size: contain;
        background-repeat: no-repeat;
      }
      .token {
        display: flex;
        padding: 7px 12px;
        justify-content: center;
        align-items: center;
        gap: 6px;
        border-radius: 14px;
        background: #070b14;
        font-size: 18px;
        font-weight: 700;
        color: #1cf2e4;
        .token-icon {
          width: 28px;
          height: 28px;
          background: url(../../assets/star/token-icon.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
    }
    .select-list {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      gap: 13px;
      margin-top: 12px;
      &-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 28px;
        border-radius: 8px;
        border: 0.6px solid #545769;
        font-size: 14px;
        color: #565662;
      }
    }
  }
  .bottom-bar {
    width: 100%;
    background: #303342;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .pay-btn {
      width: 100%;
      @include starBtn;
      &.disabled {
        pointer-events: none;
        opacity: 0.3;
      }
      &:active {
        @include btnHover;
      }
    }
  }
}
.rate-tip {
  width: 100%;
  padding: 16px;
  position: fixed;
  top: 0;
  color: #1cf2e4;
  font-size: 12px;
  background: #070b14;
  line-height: 1.4;
}
.pay-type-list {
  height: calc(100vh - 136px);
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  overflow-y: scroll;
  gap: 16px;

  &-item {
    width: 100%;
    .type-name {
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 12px;
    }
    .paytool-list {
      border-radius: 8px;
      background: #fff;
      &-item {
        display: flex;
        height: 52px;
        padding: 20px 16px;
        justify-content: start;
        align-items: center;
        &.noheight {
          height: auto;
        }
        &.nopadding {
          padding: 0;
        }
        .group-name {
          width: 100%;
          padding: 20px 16px;
          padding-bottom: 0;
          &-text {
            margin-bottom: 16px;
          }
        }
        .text {
          display: flex;
          align-items: center;
          flex: 1;
          height: 52px;
          border-bottom: 0.5px solid #eee;
          color: #111;
          font-size: 14px;
          font-weight: 400;
          .card-img {
            height: 24px;
            margin-left: 4px;
          }
          .small-text {
            color: #9c9caa;
            font-size: 10px;
            font-weight: 400;
            margin-left: 4px;
          }
        }
        .icon {
          width: 24px;
          height: 24px;
          margin-right: 12px;
        }

        .check-area {
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
          .check {
            width: 20px;
            height: 20px;
            background: url(../../assets/pay/check.svg);
            background-size: contain;
            background-repeat: no-repeat;
          }
          .right {
            width: 16px;
            height: 16px;
            background: url(../../assets/right-icon.svg);
            background-size: contain;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }
}

.pay-modal {
  gap: 24px;
  padding: 24px 16px;
  .title {
    font-size: 18px;
    color: #fff;
    font-weight: 500;
  }
  .pay-area {
    width: 100%;
    font-size: 12px;
    color: #ff3456;
    .number-font {
      font-size: 21px;
    }
  }
  .pay-btn {
    width: 343px;
    @include starBtn;
  }
}

.code-pay-modal {
  padding: 0 16px 40px 16px;
  .title {
    font-size: 18px;
    color: #fff;
    font-weight: 500;
  }
  .code {
    margin: 16px auto;
    overflow: hidden;
    line-height: 1;
    img {
      width: 160px;
    }
  }
  .copy-bar {
    display: flex;
    padding: 8px 10px;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: #1f212d;
    font-size: 14px;
    font-weight: 700;
    color: #9c9caa;
    .code-text {
      flex: 1;
      text-align: left;
    }
    .copy-icon {
      width: 20px;
      height: 20px;
      background: url(../../assets/copy.svg);
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
  .price {
    margin-top: 22px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    .number-font {
      font-size: 18px;
      font-weight: 700;
      color: rgba(28, 242, 228, 1);
    }
  }
  .save-btn {
    display: flex;
    padding: 8px 18px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    background: linear-gradient(
      111deg,
      #fff853 4.98%,
      #6eef94 56.05%,
      #2ad8cd 95.37%
    );
    color: #070b14;
    font-size: 14px;
    font-weight: 500;
    margin-top: 22px;
    cursor: pointer;
  }
  .tip {
    margin-top: 24px;
    color: #9c9caa;
    line-height: 1.6;
  }
}

#poster {
  position: fixed;
  left: -100%;
  top: -100%;
  width: 100%;
  background: linear-gradient(
    137deg,
    #4bfcc8 2.92%,
    #49fa86 9.01%,
    #39e7ff 96.65%
  );
  @media screen and (min-width: 768px) {
    width: 375px;
  }
  .poster-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 70px;
    padding: 70px 30px 70px 30px;
    .poster-title {
      color: #070b14;
      font-size: 24px;
      font-weight: 700;
    }
    .code {
      width: 205px;
      height: 205px;
      flex-shrink: 0;
      border-radius: 14px;
      overflow: hidden;
      margin-top: 44px;
    }
    .price {
      margin-top: 40px;
      font-size: 14px;
      color: #565662;
      .number-font {
        font-size: 16px;
        color: #070b14;
        font-weight: 700;
      }
    }
    .code-text {
      margin-top: 26px;
      width: 100%;
      padding: 8px 12px;
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.5);
      color: #565662;
      font-size: 14px;
      font-weight: 700;
      line-height: 18px;
      word-wrap: break-word;
      letter-spacing: 0.5px;
    }
  }
  .poster-footer {
    width: 100%;
    background: #070b14;
    padding: 18px 20px;
    .left {
      gap: 8px;
      .logo {
        width: 48px;
      }
      .text {
        width: 200px;
        color: #fff;
        font-size: 10px;
        font-weight: 400;
        line-height: 1.2;
      }
    }
  }
}
</style>
